// Page de réinitialisation du mot de passe (via lien email).
import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatErreur } from "@/lib/api";
import AuthLayout from "@/components/AuthLayout";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader2, Lock } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [motDePasse, setMotDePasse] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [erreur, setErreur] = useState("");
  const [succes, setSucces] = useState(false);
  const [chargement, setChargement] = useState(false);

  const soumettre = async (e) => {
    e.preventDefault();
    setErreur("");
    if (motDePasse.length < 6) {
      setErreur("Le mot de passe doit contenir au moins 6 caractères.");
      return;
    }
    if (motDePasse !== confirmation) {
      setErreur("Les mots de passe ne correspondent pas.");
      return;
    }
    setChargement(true);
    try {
      await api.post("/auth/reset-password", { token, nouveau_mot_de_passe: motDePasse });
      setSucces(true);
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setErreur(formatErreur(err.response?.data?.detail));
    } finally {
      setChargement(false);
    }
  };

  if (!token) {
    return (
      <AuthLayout titre="Lien invalide">
        <p className="text-sm text-[#1D3D3D]/70">
          Ce lien de réinitialisation est invalide.{" "}
          <Link to="/forgot-password" className="text-[#4A8A8A] font-semibold">Demander un nouveau lien</Link>
        </p>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout titre="Nouveau mot de passe" sousTitre="Choisissez un nouveau mot de passe sécurisé.">
      {succes ? (
        <div data-testid="message-confirmation" className="rounded-md bg-[#E8F4F4] border border-[#4A8A8A]/30 px-4 py-5 text-sm text-[#1D3D3D]">
          Mot de passe réinitialisé avec succès. Redirection vers la connexion…
        </div>
      ) : (
        <form onSubmit={soumettre} className="space-y-5" data-testid="formulaire-reinitialisation">
          {erreur && (
            <div data-testid="message-erreur" className="rounded-md bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-700">
              {erreur}
            </div>
          )}
          <div className="space-y-1.5">
            <Label htmlFor="mdp" className="text-[#1D3D3D] font-semibold">Nouveau mot de passe</Label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#4A8A8A]" />
              <Input id="mdp" type="password" data-testid="champ-mot-de-passe" value={motDePasse}
                onChange={(e) => setMotDePasse(e.target.value)} placeholder="6 caractères minimum" required
                className="pl-10 bg-white border-[#4A8A8A]/30 focus-visible:ring-[#4A8A8A]" />
            </div>
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="conf" className="text-[#1D3D3D] font-semibold">Confirmer</Label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#4A8A8A]" />
              <Input id="conf" type="password" data-testid="champ-confirmation" value={confirmation}
                onChange={(e) => setConfirmation(e.target.value)} placeholder="••••••••" required
                className="pl-10 bg-white border-[#4A8A8A]/30 focus-visible:ring-[#4A8A8A]" />
            </div>
          </div>
          <Button type="submit" data-testid="bouton-reinitialiser" disabled={chargement}
            className="w-full bg-[#1D3D3D] hover:bg-[#2D5A5A] text-white font-semibold h-11">
            {chargement ? <Loader2 className="h-4 w-4 animate-spin" /> : "Réinitialiser"}
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
